export default __webpack_public_path__ + "static/media/minivistaw-gestioria.c6542bd2.jpg";